import { Branded }	from "ts-base/branded";
import { Is }		from "ts-base/is";
import { Fn }		from "ts-base/fn";
import { Equal }	from "ts-base/equal";

export type Textual<B extends string>	= Readonly<{
	name:		string,

	brand:		Fn<string, Branded<string, B>>,
	is:			Is<string, Branded<string, B>>,

	fromString:	Fn<string, Branded<string, B>|null>,
	toString:	Fn<Branded<string, B>, string>,

	equal:		Equal<Branded<string, B>>,
}>;

export namespace Textual {
	export type Brand<T>	= T extends Textual<infer B> ? B : never;

	export type Value<T>	= T extends Textual<infer B> ? Branded<string, B> : never;

	export const typed	= <B extends string>(_companion:Textual<B>):void	=> {};
}
